import { render } from "./RestrictedAccess.vue?vue&type=template&id=3df6d4bf"
import script from "./RestrictedAccess.vue?vue&type=script&lang=js"
export * from "./RestrictedAccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__